var _defs, _path, _text, _text2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoFinalPlusName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 726.94 210.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6e07f3;}.cls-2{font-size:116.31px;}.cls-2,.cls-3{fill:#ffffff;font-family:JetBrainsMono-ExtraBold, JetBrains Mono;font-weight:800;}.cls-3{font-size:70px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.81,160a13.87,13.87,0,0,0,22.49-10.85V101.69c0-7.15-5.54-13-12.38-13H148.14c-6.83,0-12.37,5.8-12.37,13v45.69a13.86,13.86,0,0,0,22.48,10.85L182.5,139A13.87,13.87,0,0,1,205,149.85v.32a13.82,13.82,0,0,1-5.83,11.29L167.7,183.8a13.85,13.85,0,0,0,0,22.55l31.52,22.54A13.88,13.88,0,0,1,205,240.16h0A13.87,13.87,0,0,1,182.47,251l-24.2-19.28a13.86,13.86,0,0,0-22.5,10.83v43.55c0,7.15,5.54,13,12.37,13H344.92c6.84,0,12.38-5.8,12.38-13V244.31a13.87,13.87,0,0,0-22.51-10.83l-24.2,19.28a13.87,13.87,0,0,1-22.51-10.83h0a13.83,13.83,0,0,1,5.8-11.26l31.51-22.55a13.84,13.84,0,0,0,0-22.55l-31.45-22.34A13.85,13.85,0,0,1,288.08,152v-.33a13.87,13.87,0,0,1,22.48-10.85Z",
    transform: "translate(-135.77 -88.74)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(78.51 147.89) scale(0.89 1)"
  }, "C")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(213.15 133.25) scale(0.94 1)"
  }, "Caroliny Gomes")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFinalPlusName);
export default __webpack_public_path__ + "static/media/LogoFinalPlusName.c1ceb8ce675ca071cee1e36f904eabc8.svg";
export { ForwardRef as ReactComponent };